module.exports = __webpack_public_path__ + "static/img/home_2.3a81107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home_2.png
// module id = gWf7
// module chunks = 1